export default __webpack_public_path__ + "static/media/elogo-logo.05f5e8d5.svg";